import { addProps, flowMax, SimplePropsAdder } from 'ad-hok'
import { useEffect, useMemo, useState } from 'react'

// from https://usehooks.com/useWindowSize/

interface WindowSize {
  width: number
  height: number
}

const getCurrentWindowSize = (): WindowSize => ({
  width: window.innerWidth,
  height: window.innerHeight,
})

const useWindowSize = (): WindowSize => {
  const initialWindowSize = useMemo(() => getCurrentWindowSize(), [])
  const [windowSize, setWindowSize] = useState(initialWindowSize)
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    // Add event listener
    window.addEventListener('resize', handleResize)
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount
  return windowSize
}

export const addWindowSize: SimplePropsAdder<{
  windowWidth: number
  windowHeight: number
}> = flowMax(
  addProps(() => {
    const { width: windowWidth, height: windowHeight } = useWindowSize()
    return { windowWidth, windowHeight }
  })
)
